import React from 'react';
import { motion } from 'framer-motion';
interface EmotionalBridgeProps {
  text: string;
  italicPart?: string;
}
export function EmotionalBridge({
  text,
  italicPart
}: EmotionalBridgeProps) {
  return <section className="py-8 md:py-12 px-6" data-id="element-23">
      <motion.div initial={{
      opacity: 0,
      y: 15
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="max-w-xl mx-auto text-center" data-id="element-24">
        <div className="w-8 h-px bg-gold/60 mx-auto mb-5" data-id="element-25" />
        <p className="font-playfair text-[20px] md:text-2xl text-burgundy/90 leading-snug font-light" data-id="element-26">
          {text}
          {italicPart && <>
              {' '}
              <span className="italic" data-id="element-27">{italicPart}</span>
            </>}
        </p>
        <div className="w-8 h-px bg-gold/60 mx-auto mt-5" data-id="element-28" />
      </motion.div>
    </section>;
}